import Copy from "@/components/copy";
import { Button } from "@/components/ui/button";
import { handleShare } from "@/lib/helper";
import { useUser } from "@/zustand/store";
import { Share2 } from "lucide-react";

const Referral = () => {
  const { user } = useUser();
  return (
    <div className="h-[calc(100dvh-80px)]">
      <h2>Referrals</h2>
      {user?.canRefer && (
        <div className="col-span-2 mt-6 w-full grid-cols-2 flex-col justify-between gap-4 bg-linear-(--gradient-light-blue) px-4 py-4 text-white lg:col-span-1 lg:flex">
          {/* total commission */}
          <div className="flex items-center justify-between">
            <img
              className="size-8 shrink-0"
              src="/icons/gradient-users.svg"
              alt="Total Commission"
            />
            <div className="text-right font-medium">
              <p className="text-xs">Total Commission</p>
              <p className="mt-2 text-xl leading-2">
                ${user?.totalCommisions.toFixed(2)}
              </p>
            </div>
          </div>
          <div className="mt-6">
            <p className="text-sm leading-4">
              Refer friends to earn commission rewards.
            </p>
            <div className="mt-2 font-medium">
              <p className="text-xs">Commission Rate</p>
              <p className="mt-2 flex items-center gap-4 leading-2">
                <span>
                  25 <span className="text-[10px]">%(Deposit)</span>
                </span>{" "}
              </p>
            </div>
            <div className="mt-4 flex items-center gap-2.5 *:w-1/2">
              <div
                className={
                  "bg-primary-600 flex h-10 items-center justify-between rounded-md px-2.5"
                }
              >
                <span className="w-5/6 overflow-hidden text-ellipsis whitespace-nowrap">
                  {user?.id}
                </span>

                <Copy text={user?.id} icon="/icons/copy2.svg" side="left" />
              </div>
              <Button
                onClick={() => handleShare(`signup?ref=${user?.id}`)}
                className={
                  "bg-primary-100 hover:bg-primary-100/80 text-primary-600 flex h-10 items-center justify-center gap-1 rounded-md hover:cursor-pointer"
                }
              >
                <Share2 className="text-primary-600 size-4" />
                <span>Share Your Link</span>
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Referral;
